import React from 'react';

const CustomMessage = (props) => {
  //console.log(props.payload);
  return (
    <>
      <div className="ir-chat-contaner">
        <div className="custom-chat-div">
          <div className="custom-chat-div-left">
            <img src="/img/icon_chatbot.png" />
          </div>
          <div className="custom-chat-div-right">
            <div className={'ri-chat-message-bot'}>{props.payload.message}</div>
            <div className={'ri-chat-message-bot'}>
              <img
                src="https://i.pinimg.com/originals/cf/da/fa/cfdafa4dc6aab40eae1c5315c02b9339.jpg"
                style={{ width: '100%' }}
              />
            </div>
            <div className="ri-chat-time">{props.payload.writetime}</div>
          </div>
        </div>
      </div>

      {/* <div className="widget-custom-div">
        <div className={'ri-chat-message-bot'}>{props.payload.message}</div>
        <div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
          <img
            src="https://i.pinimg.com/originals/cf/da/fa/cfdafa4dc6aab40eae1c5315c02b9339.jpg"
            style={{ width: '100%' }}
          />
        </div>
      </div>
      <div className="ri-chat-time">{props.payload.writetime}</div> */}
    </>
  );
};

export default CustomMessage;
